// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SelectSearch_wrapper___jImC","closeIcon":"SelectSearch_closeIcon__3Un69"};